import React from 'react';
import SummaryDebtArea from '../../views/SummaryDebtArea';

const Overview = ({ isFastPay }) => {
	return (
		<SummaryDebtArea isFastPay={isFastPay} />
	);
};

export default Overview;
